








































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { StSelectListItemGroup } from '@/services/api/nswag/stapiclient_generated';

@Component({
  components: {},
})
export default class StopwatchSelect extends Vue {
  @Prop() value!: number;
  @Prop() projects!: StSelectListItemGroup[];
  @Prop() lastProjects!: StSelectListItemGroup[];
  @Prop({ default: false }) openOnMounted!: boolean;
  @Prop() startStopLoading!: boolean;

  delLoading: boolean = false;

  projectSelectQuery: string = '';
  projectSelectIsOpen = false;

  get projectId() {
    return this.value;
  }

  set projectId(data: number) {
    this.$emit('input', data);
  }

  setProjectSelectIsOpenFalse() {
    this.projectSelectIsOpen = false;
    this.$emit('blur');
  }

  projectSelectSearchTriggered(query: any) {
    this.projectSelectQuery = query;
  }

  get getProjectOptions() {
    if (this.projectSelectQuery) {
      return this.projects;
    }

    return this.projects;
  }

  start(projectId: number) {
    this.$emit('start', projectId);
  }
}
